import {TranslationObject} from '@colonist/i18n'
import {PIXI} from '@colonist/pixi'
import {UIGameToolTipController} from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipController'
import {UIWGameToolTipView} from './UIWGameToolTipView'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {UIGameToolTipView} from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipView'
import {isDescendantOf} from '../../../../shared/scripts/ui_utils/PixiUtils'
import {TimeoutId} from '@colonist/types'

export type ToolTipText = () => {title: TranslationObject, body: TranslationObject[]}

export class UIWGameToolTipController extends UIGameToolTipController {
    private hoverCheckInterval: TimeoutId | undefined
    private hoverCheckCounter: number = 0

    private readonly hoverCheckIntervalMS: number = 100
    private readonly timeoutToOpenTooltipMS: number = 500
    private readonly hoverCheckCounterThreshold: number = 15 * 1000 / this.hoverCheckIntervalMS

    startedHovering(toolTipText: ToolTipText, view: PIXI.Container) {
        setTimeout(() => {
            if(this.isCursorOverContainer(view)) this.openTip(toolTipText, view)
        }, this.timeoutToOpenTooltipMS)
    }

    private isCursorOverContainer(view: PIXI.Container): boolean {
        const boundary = this.app.renderer.events.rootBoundary
        const mouse = this.app.renderer.events.pointer.global
        const topObject = boundary.hitTest(mouse.x, mouse.y)
        return topObject === view
    }

    createTip(toolTipText: ToolTipText, view: PIXI.Container): void {
        const {title, body} = toolTipText()
        if(clientI18n.t(title.key, title.options) == '' && clientI18n.t(body[0].key, body[0].options) == '') return
        view.interactive = true
        view.on('pointerover', (event) => this.startedHovering(toolTipText, view))
        view.on('pointerout', (event) => this.closeTip())
    }

    createTipFromTooltipView(getTooltipView: () => UIGameToolTipView, view: PIXI.Container): void {
        view.interactive = true
        view.on('pointerover', (event) => {
            this.closeTip()
            this.tip = getTooltipView()
        })
        view.on('pointerout', (event) => this.closeTip())
    }

    private startHoverCheck(view: PIXI.Container): void {
        this.hoverCheckInterval = setInterval(() => {
            this.hoverCheckCounter += 1
            const toolTipTooOld = this.hoverCheckCounter > this.hoverCheckCounterThreshold

            const shouldCloseTip = toolTipTooOld || !this.isCursorOverContainer(view)
            if(shouldCloseTip) this.closeTip()
        }, this.hoverCheckIntervalMS)
    }

    private stopHoverCheck(): void {
        clearInterval(this.hoverCheckInterval)
    }

    override disableTip(view: PIXI.Container) {
        super.disableTip(view)
        view.off('pointerover')
        view.off('pointerout')
    }

    openTip(toolTipText: ToolTipText, view: PIXI.Container) {
        this.closeTip()
        const {title, body} = toolTipText()
        if(!isDescendantOf(view, this.app.stage)) return
        this.tip = new UIWGameToolTipView(view, title, body)
        this.startHoverCheck(view)
    }

    closeTip() {
        super.closeTip()
        this.stopHoverCheck()
        this.hoverCheckCounter = 0
    }
}
